var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"app"}},[_c('div',[_c('div',{staticClass:"bouncefix"}),_c('router-view',{staticClass:"pageview"}),(!_vm.keyboard)?_c('NavBar'):_vm._e()],1)]),_c('modal')],1)}
var staticRenderFns = []

export { render, staticRenderFns }